<template>
  <NovaRequisicaoBalcaoComponent
    :category="2"
    :title="'Requisição Balcão Uniformes'"
  />
</template>

<script>
import NovaRequisicaoBalcaoComponent from "../components/NovaRequisicaoBalcaoComponent.vue";
export default {
  components: {
    NovaRequisicaoBalcaoComponent,
  },
};
</script>

<style></style>
